import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { AuthService } from "@core/auth.service";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { IonicModule } from "@ionic/angular";
@Component({
    selector: "app-close-account",
    templateUrl: "./close-account.component.html",
    styleUrls: ["./close-account.component.scss"],
    standalone: true,
    imports: [IonicModule, TranslatePipe],
})
export class CloseAccountComponent implements OnInit {
  constructor(private dialog: MatDialogRef<CloseAccountComponent>,
    private authService: AuthService,
    public translate: TranslateService) {
    this.authService?.selectedlanguage$?.subscribe((l) => {
      if (l) {
        translate.use(l ? l : "en");
      }
    }, err => { return (err) });

  }

  ngOnInit() { }

  cancel() {
    this.dialog.close(false);
  }

  closeAccount() {
    this.dialog.close(true);
  }
}
